import { http } from "@/shared/api/http";
import type { CommanderAnswers, CommanderResponse } from "./types";

export const submitCommander = (answers: CommanderAnswers): Promise<CommanderResponse> =>
  http<CommanderResponse>("/orchestration/commander", {
    method: "POST",
    body: { answers },
  });

// ── Patch 37.4.39 · Editable Resume + Archive / Restore ─────────────

export interface BlueprintForResume {
  id: string;
  status: string;
  commander_answers: CommanderAnswers;
  workspace_id: string;
}

export const fetchBlueprint = (id: string): Promise<{ blueprint: BlueprintForResume }> =>
  http<{ blueprint: BlueprintForResume }>(`/orchestration/blueprints/${id}`);

export const updateBlueprintAnswers = (
  id: string, answers: CommanderAnswers,
): Promise<{ blueprint: BlueprintForResume }> =>
  http<{ blueprint: BlueprintForResume }>(
    `/orchestration/blueprints/${id}/answers`,
    { method: "PATCH", body: answers },
  );

export const archiveBlueprint = (
  id: string, reason?: string,
): Promise<{ blueprint: BlueprintForResume }> =>
  http<{ blueprint: BlueprintForResume }>(
    `/orchestration/blueprints/${id}/archive`,
    { method: "POST", body: reason ? { reason } : {} },
  );

export const restoreBlueprint = (
  id: string,
): Promise<{ blueprint: BlueprintForResume }> =>
  http<{ blueprint: BlueprintForResume }>(
    `/orchestration/blueprints/${id}/restore`,
    { method: "POST" },
  );
